import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type FacilityDeletionFailedAction = {
	type: 'FACILITY_DELETION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): FacilityDeletionFailedAction => ({
	type: 'FACILITY_DELETION_FAILED',
	payload,
});
